import { CampaignMaterialActionsController } from './campaign-material-actions.controller'

function campaignMaterialActions () {
  return {
    scope: {
      campaign: '=',
      action: '<'
    },
    restrict: 'E',
    templateUrl: '/campaigns/directives/campaign-material-actions/campaign-material-actions.html?$$REVISION$$',
    controller: CampaignMaterialActionsController
  }
}

export { campaignMaterialActions }
